export default "__VITE_ASSET__cbdb2ec7__"